function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useRef } from 'react';
import { SortDescendingIcon, SortAscendingIcon } from '@shopify/polaris-icons';
import { classNames, variationName } from '../../../../utilities/css.js';
import { headerCell } from '../../../shared.js';
import styles from '../../DataTable.scss.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
import { Icon } from '../../../Icon/Icon.js';
function Cell(_ref) {
  var content = _ref.content,
    contentType = _ref.contentType,
    nthColumn = _ref.nthColumn,
    firstColumn = _ref.firstColumn,
    truncate = _ref.truncate,
    header = _ref.header,
    total = _ref.total,
    totalInFooter = _ref.totalInFooter,
    sorted = _ref.sorted,
    sortable = _ref.sortable,
    sortDirection = _ref.sortDirection,
    inFixedNthColumn = _ref.inFixedNthColumn,
    _ref$verticalAlign = _ref.verticalAlign,
    verticalAlign = _ref$verticalAlign === void 0 ? 'top' : _ref$verticalAlign,
    _ref$defaultSortDirec = _ref.defaultSortDirection,
    defaultSortDirection = _ref$defaultSortDirec === void 0 ? 'ascending' : _ref$defaultSortDirec,
    onSort = _ref.onSort,
    colSpan = _ref.colSpan,
    _ref$setRef = _ref.setRef,
    setRef = _ref$setRef === void 0 ? function () {} : _ref$setRef,
    _ref$stickyHeadingCel = _ref.stickyHeadingCell,
    stickyHeadingCell = _ref$stickyHeadingCel === void 0 ? false : _ref$stickyHeadingCel,
    stickyCellWidth = _ref.stickyCellWidth,
    _ref$hovered = _ref.hovered,
    hovered = _ref$hovered === void 0 ? false : _ref$hovered,
    _ref$handleFocus = _ref.handleFocus,
    handleFocus = _ref$handleFocus === void 0 ? function () {} : _ref$handleFocus,
    _ref$hasFixedNthColum = _ref.hasFixedNthColumn,
    hasFixedNthColumn = _ref$hasFixedNthColum === void 0 ? false : _ref$hasFixedNthColum,
    _ref$fixedCellVisible = _ref.fixedCellVisible,
    fixedCellVisible = _ref$fixedCellVisible === void 0 ? false : _ref$fixedCellVisible,
    firstColumnMinWidth = _ref.firstColumnMinWidth,
    style = _ref.style,
    lastFixedFirstColumn = _ref.lastFixedFirstColumn;
  var i18n = useI18n();
  var numeric = contentType === 'numeric';
  var className = classNames(styles.Cell, styles["Cell-".concat(variationName('verticalAlign', verticalAlign))], firstColumn && styles['Cell-firstColumn'], truncate && styles['Cell-truncated'], header && styles['Cell-header'], total && styles['Cell-total'], totalInFooter && styles['Cell-total-footer'], numeric && styles['Cell-numeric'], sortable && styles['Cell-sortable'], sorted && styles['Cell-sorted'], stickyHeadingCell && styles.StickyHeaderCell, hovered && styles['Cell-hovered'], lastFixedFirstColumn && inFixedNthColumn && fixedCellVisible && styles['Cell-separate'], nthColumn && inFixedNthColumn && stickyHeadingCell && styles.FixedFirstColumn);
  var headerClassName = classNames(header && styles.Heading, header && contentType === 'text' && styles['Heading-left']);
  var iconClassName = classNames(sortable && styles.Icon);
  var direction = sorted && sortDirection ? sortDirection : defaultSortDirection;
  var source = direction === 'descending' ? SortDescendingIcon : SortAscendingIcon;
  var oppositeDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
  var sortAccessibilityLabel = i18n.translate('Polaris.DataTable.sortAccessibilityLabel', {
    direction: sorted ? oppositeDirection : direction
  });
  var iconMarkup = /*#__PURE__*/React.createElement("span", {
    className: iconClassName
  }, /*#__PURE__*/React.createElement(Icon, {
    source: source,
    accessibilityLabel: sortAccessibilityLabel
  }));
  var focusable = !(stickyHeadingCell && hasFixedNthColumn && nthColumn && !inFixedNthColumn);
  var sortableHeadingContent = /*#__PURE__*/React.createElement("button", {
    className: headerClassName,
    onClick: onSort,
    onFocus: handleFocus,
    tabIndex: focusable ? 0 : -1
  }, iconMarkup, content);
  var columnHeadingContent = sortable ? sortableHeadingContent : content;
  var colSpanProp = colSpan && colSpan > 1 ? {
    colSpan: colSpan
  } : {};
  var minWidthStyles = nthColumn && firstColumnMinWidth ? {
    minWidth: firstColumnMinWidth
  } : {
    minWidth: stickyCellWidth
  };
  var stickyHeading = /*#__PURE__*/React.createElement("th", Object.assign({
    ref: setRef
  }, headerCell.props, colSpanProp, {
    className: className,
    "aria-sort": sortDirection,
    style: _objectSpread(_objectSpread({}, style), minWidthStyles),
    "data-index-table-sticky-heading": true
  }), columnHeadingContent);
  var headingMarkup = header ? /*#__PURE__*/React.createElement("th", Object.assign({}, headerCell.props, {
    "aria-sort": sortDirection
  }, colSpanProp, {
    ref: setRef,
    className: className,
    scope: "col",
    style: _objectSpread({}, minWidthStyles)
  }), columnHeadingContent) : /*#__PURE__*/React.createElement("th", Object.assign({}, colSpanProp, {
    ref: setRef,
    className: className,
    scope: "row",
    style: _objectSpread({}, minWidthStyles)
  }), truncate ? /*#__PURE__*/React.createElement(TruncatedText, {
    className: styles.TooltipContent
  }, content) : content);
  var cellMarkup = header || firstColumn || nthColumn ? headingMarkup : /*#__PURE__*/React.createElement("td", Object.assign({
    className: className
  }, colSpanProp), content);
  return stickyHeadingCell ? stickyHeading : cellMarkup;
}
var TruncatedText = function TruncatedText(_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className;
  var textRef = useRef(null);
  var current = textRef.current;
  var text = /*#__PURE__*/React.createElement("span", {
    ref: textRef,
    className: className
  }, children);
  return (current === null || current === void 0 ? void 0 : current.scrollWidth) > (current === null || current === void 0 ? void 0 : current.offsetWidth) ? /*#__PURE__*/React.createElement(Tooltip, {
    content: textRef.current.innerText
  }, text) : text;
};
export { Cell };